// import { merchantStroe } from "@/stores";

export const findMenuItemById = (items: any, targetId: string) => {
  for (const item of items) {
    if (item.id === targetId) {
      return item;
    }
    if (item.children && Array.isArray(item.children)) {
      const foundItem: any = findMenuItemById(item.children, targetId);
      if (foundItem) {
        return foundItem;
      }
    }
  }
  return null;
};

export function getCookieByName(name: string) {
  // 获取所有 cookie，返回的是一个字符串，多个 cookie 用 "; " 分隔
  const cookies = document.cookie.split("; ");

  // 遍历 cookie 数组，查找指定名称的 cookie
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split("=");

    if (cookieName === name) {
      return cookieValue; // 返回找到的第一个 cookie 值
    }
  }

  // 如果未找到，返回 null
  return null;
}

export function customFetch(
  url: string | URL,
  options: {
    method: string;
    headers: { [x: string]: string };
    body: XMLHttpRequestBodyInit | null | undefined;
  }
) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const method = options.method || "GET";

    xhr.open(method, url, true);

    // Set headers if provided
    if (options.headers) {
      for (let key in options.headers) {
        xhr.setRequestHeader(key, options.headers[key]);
      }
    }

    // Setup the onload event handler to process the response
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({
          ok: true,
          status: xhr.status,
          statusText: xhr.statusText,
          json: () => Promise.resolve(JSON.parse(xhr.responseText)),
          text: () => Promise.resolve(xhr.responseText),
        });
      } else {
        reject({
          ok: false,
          status: xhr.status,
          statusText: xhr.statusText,
        });
      }
    };

    // Handle network errors
    xhr.onerror = () => {
      reject({
        ok: false,
        status: xhr.status,
        statusText: "Network Error",
      });
    };

    // Send the request
    if (method === "GET" || !options.body) {
      xhr.send();
    } else {
      xhr.send(options.body);
    }
  });
}

export function sleep(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
